/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SupplierRequestModel model module.
 * @module model/SupplierRequestModel
 * @version v1.0.0
 */
class SupplierRequestModel {
    /**
     * Constructs a new <code>SupplierRequestModel</code>.
     * @alias module:model/SupplierRequestModel
     * @param name {String} Name (required)
     */
    constructor(name) { 
        
        SupplierRequestModel.initialize(this, name);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, name) { 
        obj['name'] = name;
    }

    /**
     * Constructs a <code>SupplierRequestModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SupplierRequestModel} obj Optional instance to populate.
     * @return {module:model/SupplierRequestModel} The populated <code>SupplierRequestModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SupplierRequestModel();

            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('mainId')) {
                obj['mainId'] = ApiClient.convertToType(data['mainId'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('seq')) {
                obj['seq'] = ApiClient.convertToType(data['seq'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * code
 * @member {String} code
 */
SupplierRequestModel.prototype['code'] = undefined;

/**
 * Description
 * @member {String} description
 */
SupplierRequestModel.prototype['description'] = undefined;

/**
 * Foreign Key
 * @member {String} mainId
 */
SupplierRequestModel.prototype['mainId'] = undefined;

/**
 * Name (required)
 * @member {String} name
 */
SupplierRequestModel.prototype['name'] = undefined;

/**
 * seq
 * @member {Number} seq
 */
SupplierRequestModel.prototype['seq'] = undefined;






export default SupplierRequestModel;

